"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountrySelect = void 0;
Object.defineProperty(exports, "useCountryOptions", {
  enumerable: true,
  get: function get() {
    return _useCountryOptions.useCountryOptions;
  }
});
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _SearchSelect = require("../search-select/SearchSelect");
var _react = _interopRequireDefault(require("react"));
var _useCountryOptions = require("./hooks/useCountryOptions");
var _excluded = ["countryCodes"];
var CountrySelect = function CountrySelect(_ref) {
  var countryCodes = _ref.countryCodes,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var countryOptions = (0, _useCountryOptions.useCountryOptions)(countryCodes);
  var props = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, rest), {}, {
    options: countryOptions
  });
  return /*#__PURE__*/_react.default.createElement(_SearchSelect.SearchSelect, props);
};
exports.CountrySelect = CountrySelect;